import instance from './axiosInstance';
import type { AlertForwardRule, AlertForwardMeta } from 'pages/AIAlertForward/utils/types';

export const getAlertForwardRule = async <T = AlertForwardRule[]>(): Promise<T> => {
  const res = await instance.get('/alert-forward/list');
  return res.data;
};

export const getAlertForwardMeta = async <T = AlertForwardMeta>(): Promise<T> => {
  const res = await instance.get('/alert-forward/meta');
  return res.data;
};

export const setAlertForwardRule = async (rule: AlertForwardRule): Promise<any> => {
  const res = await instance.post('/alert-forward/edit', rule);
  return res.data;
};

export const setAlertForwardRuleToggle = async (rule: AlertForwardRule): Promise<any> => {
  const res = await instance.post(`/alert-forward/toggle-enable`, rule);
  return res.data;
};

export const deleteAlertForwardRule = async (ruleId: number): Promise<any> => {
  const res = await instance.delete(`/alert-forward/${ruleId}`);
  return res.data;
};
